import { EventEmitter } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ConfigService } from "./config.service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class DashboardService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        this.jsonContent = {
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                Authorization: sessionStorage.getItem("batoken"),
                User: sessionStorage.getItem("userid"),
            }),
        };
        this.invokeFirstComponentFunction = new EventEmitter();
    }
    getListaCapacitacionesRealizadas(idUser) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/capacitaciones-realizadas?idUser=${idUser}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    getListaCapacitacionesMes(idUser) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/capacitaciones-mes?idUser=${idUser}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    getListaCapacitacionesNoRealizadas(idUser) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/capacitaciones-no-realizadas?idUser=${idUser}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    getZonas() {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/find-zonas`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    getZonasUser() {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/find-zonas-user`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    getHorasZona(anio, mes, zona, tipoCapacitacion) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/resumen-hh-zona?anio=${anio}&mes=${mes}&zona=${zona}&tipoCapacitacion=${tipoCapacitacion}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    getHorasFoco(anio, mes, zona, tipoCapacitacion) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/resumen-hh-foco?anio=${anio}&mes=${mes}&zona=${zona}&tipoCapacitacion=${tipoCapacitacion}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    getHorasRealizadas(anio, mes, zona, tipoCapacitacion) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/resumen-hh-realizadas?anio=${anio}&mes=${mes}&zona=${zona}&tipoCapacitacion=${tipoCapacitacion}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    getCapacRealizadasNoRealizadas(anio, mes, zona, tipoCapacitacion) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/resumen-capac-realizadas-norealizadas?anio=${anio}&mes=${mes}&zona=${zona}&tipoCapacitacion=${tipoCapacitacion}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    getResumenCapacitaciones(anio, mes, zona, tipoCapacitacion) {
        return this.http.get(`${this.configService.API_URL}/capacitaciones/resumen-capacitaciones?anio=${anio}&mes=${mes}&zona=${zona}&tipoCapacitacion=${tipoCapacitacion}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
}
DashboardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DashboardService_Factory() { return new DashboardService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: DashboardService, providedIn: "root" });
